import { Categories } from '@features/categories/pages/Categories';
import { Property } from 'shared-types/Property';
import * as entityActions from '@store/entity/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { NextPage, NextPageContext } from 'next';
import NextSeo from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { useTranslations } from '@lang';

type CategoriesPageProps = {
  language: string;
  url: string;
  property: Property;
};
const CategoriesPage: NextPage<CategoriesPageProps> = ({ property, language, url }) => {
  const { t } = useTranslations();
  const pageName = t('flynav.offers');

  const pageTitle = property?.propertyTitle ? `${pageName} | ${property.propertyTitle}` : pageName;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <NextSeo
        config={{
          openGraph: {
            title: pageTitle,
            locale: language,
            url,
            images: [{ url: property?.socialFallbackImage?.url }],
          },
        }}
      />
      <Categories />
    </>
  );
};

type CategoriesPageInitialProps = {
  property: Property;
  store: NormalizedStore;
} & NextPageContext &
  Pick<CategoriesPageProps, 'language' | 'url'>;

CategoriesPage.getInitialProps = async ({
  store,
  property,
  language,
  url,
}: CategoriesPageInitialProps) => {
  await entityActions.fetchCategories(property.id, language)(store.dispatch);

  return {
    url,
    language,
    property,
  } as CategoriesPageProps;
};

export default CategoriesPage;
